<template  lang="pug">
.container-fluid.fix-it
  // ==============================================================
  // Bread crumb and right sidebar toggle
  // ==============================================================
  .row(:class="{'page-header-custom-web': !isMobile()}")
    .col-6.text-left.left-section
      h3.m-0(v-if="!isMobile()")
        | {{pageTitle(true) | capitalize}}
        i.mdi.mdi-refresh.cursor-hand.m-l-5.p-r-t-1(@click="reloadFeed()" title="Refresh the feed to pull newer posts.")
      h4.m-0(v-if="isMobile()")
        | {{pageTitle(true) | capitalize}}
        i.mdi.mdi-refresh.cursor-hand.m-l-5.p-r-t-1(@click="reloadFeed()" title="Refresh the feed to pull newer posts.")
    .col-6.text-right
      .btn-group.btn-add-feed
        button.btn.waves-effect.waves-light.btn-info.dropdown-toggle.btn-circle.f-s-17(type="button"  data-placement="left" title="Click to post something" data-toggle='dropdown', aria-haspopup='true', aria-expanded='true' :class="{'btn-sm': isMobile()}")
          i.fa.fa-plus
          //span
            | Post
        .dropdown-menu(x-placement='bottom-start')
          a.dropdown-item(href='javascript:void(0)' v-for="pOpt in postOptions" @click="triggerPostPopup(pOpt)")
            i.fa.m-r-5(:class="pOpt.icon")
            | {{pOpt.label}}
          <router-link tag="a" :to="postAnswerPageLink()" class="dropdown-item">
            i.mdi.mdi-comment-plus-outline
            |  Video Answer
          </router-link>
  .row.dashboard-feed-view
    .col-12.feed-container-col
      .card
        .card-body.bg-special-1
          .feed-preloader(v-show="preloader")
            <preloader></preloader>
          <feed @VideoPlayed = "VideoPlayed" :triggerPopupView = "true" v-if="!preloader" :feed="feed" :userFeed="true" :customClasses="'p-10-ns'"></feed>
          .nothing-to-show(v-show="feed.length && !newsFeedEnabled && !adEnabled")
            .jumbotron.white-back.text-center
              h1.display-3 Dead End!
              p.lead
                | You need to enable either News Feed or Ads to see something here.
              hr.my-4
              p
                | Currently, you have disabled both.
          div.load-more-posts.text-center(v-infinite-scroll="loadMoreFeed" infinite-scroll-disabled="disableLoadMore" infinite-scroll-distance="300")
            <preloader v-show="loadMorePreloader"></preloader>
            span(v-show="noMoreFeed && feed.length")
              i.mdi.mdi-emoticon-sad.m-r-5
              | No more feed
  <status-update @statusPosted="postStatus" :options="postOptionsDefault" :currentTag="getCat()"></status-update>
  // ==============================================================
  // End Right sidebar
  // ==============================================================
  <overlay-view :noMoreFeed = "noMoreFeed" :popupFeed="feed" @ReloadFeed="reloadFeed()" @GetMoreFeed="loadMoreFeed()" ref="overlayViewComp"/>
  <ad-popup @AdTutorialTaken = "closeOverlayView" @StepChanged= 'adTutorialStepChanged' ref="AdPopupComp"/>
</template>

<script>
import mixin from '../../globals/mixin.js'
import Preloader from './../../components/preloader'
import TotalRevenue from './../../components/total-revenue'
import StatusUpdate from './components/status-update/main'
import Feed from './../../components/feed/feed'
import Service from './service'
import auth from '@/auth/helpers'
import TitleCollapse from '../../components/title-collapse'
import OverlayView from './overlay-view/overlay-view'
import AdPopup from './../../components/ad-system/ad-popup'

export default {
  name: 'Dashboard',
  service: new Service(),
  components: {
    StatusUpdate,
    Feed,
    Preloader,
    TotalRevenue,
    TitleCollapse,
    OverlayView,
    AdPopup
  },
  mixins: [mixin],
  props: {
    cat: {
      type: String,
      default: 'Home'
    }
  },
  data () {
    return {
      adEnabled: true,
      newsFeedEnabled: true,
      newCommentText: '',
      postOptionsDefault: {},
      preloader: true,
      disableLoadMore: true,
      loadMorePreloader: false,
      currentPage: 1,
      noMoreFeed: false,
      currentUser: auth.getUser(),
      adReminderInterval: false,
      truncateFeedConf: {
        enable: true,
        maxPostsCount: 70,
        postsToRemove: 35
      },
      videosWatchedForAdTutorial: 9,
      postOptions: [
        /* {
          type: 'text',
          label: 'Status Update',
          icon: 'fa-bullhorn',
          popupTitle: 'Share Something New',
          buttonLabel: 'Share',
          showPopup: false
        }, */
        {
          type: 'question',
          label: 'Ask Question',
          icon: 'fa-question-circle',
          popupTitle: 'Ask your question',
          buttonLabel: 'Ask',
          showPopup: false

        },
        /* {
          type: 'picture',
          label: 'Pictures',
          icon: 'fa-image',
          popupTitle: 'Post Pictures',
          buttonLabel: 'Post',
          showPopup: false

        }, */
        {
          type: 'video',
          label: 'Video',
          icon: 'fa-video-camera',
          popupTitle: 'Post a video',
          buttonLabel: 'Post',
          showPopup: false

        }
      ],
      feed: []
    }
  },
  watch: {
    'currentUser.adsEnabled' () {
      this.updateFeedPreference()
      this.adReminder()
    },
    'currentUser.feedEnabled' () {
      this.updateFeedPreference()
    },
    'currentUser.recentActivitiesEnabled' () {
      this.updateFeedPreference()
    },
    'currentUser.unCommentedEnabled' () {
      this.updateFeedPreference()
    },
    '$store.state.auth.user' (user) {
      this.currentUser = user
    },
    feed () {
      this.feed = this.prepareFeed(this.feed)
    },
    '$route.params.cat' (newCat) {
      this.scrollToTop()
      this.categoryChanged(newCat)
    },
    '$store.state.auth.WVC.d' (newV) {
      if (newV && auth.watchedVideoCount().getCount() >= this.videosWatchedForAdTutorial) {
        auth.watchedVideoCount().reset()
        // this.$refs.AdPopupComp.triggerPopup()
      }
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle()
    }
  },
  created () {
    this.showHideFeed()
    this.setPostDefaultOptions()
  },
  mounted () {
    this.getFeed()
    this.adReminder()
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.adReminderInterval)
    next()
  },
  methods: {
    adTutorialStepChanged (step) {
      if (step === 2) {
        this.closeOverlayView()
      }
    },
    adReminder () {
      let showMessage = (stats) => {
        let text = ''
        let tip = 'Tip'
        if (stats.newAdsRemaining) {
          toggleTips().set('enable')
          if (stats.videosToWatch) {
            if (stats.videosToWatch >= 9) {
              text = 'Watch videos to unlock ads'
            } else if (stats.videosToWatch >= 5 && stats.videosToWatch < 9) {
              tip = 'Keep watching videos'
              text = 'New ad is unlocking very soon'
            } else if (stats.videosToWatch >= 1 && stats.videosToWatch < 5) {
              tip = 'Almost there'
              text = 'New ad will unlock anytime now, keep watching'
            }
          } else {
            tip = 'Ad unlocked'
            text = 'It will show up anytime now, keep watching'
          }
          showTip(text, tip)
        }
      }
      let showTip = (text, title, time = 5000) => {
        this.showNotification(text, 'info', time, {
          title: title,
          ignoreDuplicates: true,
          data: {
            symbol: this.getUserCurrencySymbol()
          }
        }, 'tips')
      }
      let toggleTips = () => {
        let key = 'STIP'
        return {
          set: (action) => {
            localStorage.setItem(key, (action === 'enable'))
          },
          get: () => {
            let item = localStorage.getItem(key)
            return item && item === 'true'
          }
        }
      }
      clearInterval(this.adReminderInterval)
      this.adReminderInterval = setInterval(() => {
        let user = auth.getUser()
        if (user.adsEnabled) {
          this.$options.service.getAdReminderStats()
            .then((d) => {
              if (d.stats.clearInterval) {
                clearInterval(this.adReminderInterval)
                if (toggleTips().get()) {
                  showTip('You can keep watching the videos and enjoy', 'More ads will unlock tommorrow', 7000)
                  toggleTips().set('disable')
                }
              } else {
                showMessage(d.stats)
              }
            })
        }
      }, 200000)
    },
    updateFeedPreference () {
      this.noMoreFeed = false
      // this.showHideFeed()
      // this.showNotification('Updating, please wait...', 'warn')
      auth.updateCurrentUser(this.currentUser)
        .then((data) => {
          this.showNotification('Preferences updated', 'success')
          this.reloadFeed()
        })
        .catch((pErr) => {
          this.showNotification('Soemthing went wrong while updating your preferences', 'error')
        })
    },
    VideoPlayed (obj) {
      this.$refs.overlayViewComp.triggerPopup(obj)
    },
    closeOverlayView () {
      this.$refs.overlayViewComp.closePopup(false)
    },
    reloadFeed () {
      this.resetFeed()
      this.getFeed()
    },
    resetFeed () {
      this.feed = []
      this.noMoreFeed = false
      this.currentPage = 1
    },
    getFeed () {
      if (this.currentPage === 1) {
        this.preloader = true
        this.scrollToTop()
      }
      let that = this
      this.$options.service.getFeed(that.getCat(), that.currentPage)
        .then((data) => {
          that.afterFeedLoad(data)
        })
        .catch((feedError) => {
          this.showNotification('Something went wrong file fetching the feed under this tag.', 'error')
        })
    },
    categoryChanged (newCat) {
      this.resetFeed()
      this.setDocumentTitle(newCat)
      this.getFeed()
    },
    /* getPostsIds () {
      let arr = []
      for (let i in this.feed) {
        arr.push(this.feed[i].id)
      }
      return arr
    },
    removeDuplicates (posts) {
      if (this.feed.length) {
        let uniquePosts = []
        let postIds = this.getIds(this.feed)
        for (let i in posts) {
          if (postIds.indexOf(posts[i].id) === -1) {
            uniquePosts.push(posts[i])
          }
        }
        return uniquePosts
      }
      return posts
    }, */
    autoTriggerOverlayView () {
      let key = 'overlayViewTriggered'
      let overlayViewTriggered = sessionStorage.getItem(key)
      if (overlayViewTriggered === null) {
        this.$refs.overlayViewComp.triggerPopup()
        sessionStorage.setItem(key, true)
      }
    },
    /*
    * method to remove last n posts
    * if posts count reaches a predfined limit
    * this is to keep the Posts count low enough
    * to prevent web pages from hanging if post
    * count gets too high
    */
    truncateFeed () {
      if (this.truncateFeedConf.enable && this.feed.length >= this.truncateFeedConf.maxPostsCount) {
        this.feed.splice(0, this.truncateFeedConf.postsToRemove)
      }
    },
    feedHasVideo () {
      if (this.feed.length) {
        for (let i in this.feed) {
          if (this.feed[i].type === 'video' || this.feed[i].defaultComment) {
            return true
          }
        }
      }
      return false
    },
    afterFeedLoad (data) {
      this.feed = this.feed.concat(this.removeDuplicates(this.feed, data.posts))
      this.truncateFeed()
      if (this.currentPage === 1 && this.feedHasVideo()) {
        // disable auto triggering Overlay View
        // this.autoTriggerOverlayView()
      }
      if ('nextPage' in data && data.nextPage) {
        this.currentPage = data.nextPage
      } else {
        this.currentPage++
      }
      this.preloader = false
      this.loadMorePreloader = false
      if (!data.posts.length) {
        this.noMoreFeed = true
      } else {
        this.disableLoadMore = false
      }
    },
    prepareFeed (posts) {
      /* for (let i in posts) {
        // add new proprties
        this.$set(posts[i], 'show', true)
        this.$set(posts[i], 'showComments', true)
      } */
      return posts
    },
    showHideFeed () {
      for (var i in this.feed) {
        if (this.feed[i]['AdOption']) {
          this.feed[i]['show'] = this.currentUser.adsEnabled
        } else {
          this.feed[i]['show'] = this.currentUser.feedEnabled
        }
      }
    },
    getTitle () {
      return this.$route.params.cat
    },
    pageTitle (breadcrumb = false) {
      var t = this.getTitle()
      return !t || t === 'all' ? (breadcrumb ? 'Main Feed' : 'Home') : t
    },
    postStatus (feed) {
      this.feed.unshift(feed)
    },
    setPostDefaultOptions () {
      this.postOptionsDefault = this.postOptions[0]
    },
    getCat () {
      return this.$route.params.cat || 'all'
    },
    triggerPostPopup (postOptions) {
      var max = 1000000
      var min = 1
      postOptions.showPopup = Math.floor(Math.random() * (+max - +min)) + +min
      this.postOptionsDefault = postOptions
    },
    loadMoreFeed () {
      if (!this.noMoreFeed) {
        this.loadMorePreloader = true
        this.disableLoadMore = true
        this.getFeed()
      }
    }
  }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/features/dashboard/main.vue